import { render } from "./ValidationTable.vue?vue&type=template&id=ec6964f2&scoped=true&ts=true"
import script from "./ValidationTable.vue?vue&type=script&lang=ts"
export * from "./ValidationTable.vue?vue&type=script&lang=ts"

import "./ValidationTable.vue?vue&type=style&index=0&id=ec6964f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec6964f2"]])

export default __exports__